"use client";

import { Box, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import React from 'react';
import ApiKeyCard from './ApiKeyCard';
import UsageWarningBanner from './UsageWarningBanner';
import { colors, typography } from '@/theme/colors';
interface ApiKey {
  id: number;
  name: string;
  prefix: string;
  is_active: boolean;
  created_at: string;
  last_used_at: string | null;
}
interface StoreUsage {
  requests_used: number;
  requests_limit: number;
  resets_at: string;
  plan_name?: string;
}
interface ApiKeysListProps {
  keys: ApiKey[];
  onRevoke: (keyId: number) => void;
  storeUsage: StoreUsage | null;
}

/**
 * List of API keys with store-level usage warning
 */
const ApiKeysList: React.FC<ApiKeysListProps> = ({
  keys,
  onRevoke,
  storeUsage
}) => {
  const t = useTranslations('apiKeys');

  // Calculate store-level usage percentage
  const usagePercentage = storeUsage ? Math.min(storeUsage.requests_used / storeUsage.requests_limit * 100, 100) : 0;
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  }} data-sentry-element="Box" data-sentry-component="ApiKeysList" data-sentry-source-file="ApiKeysList.tsx">
      {/* Warning Banner based on store-wide usage */}
      <UsageWarningBanner percentageUsed={usagePercentage} data-sentry-element="UsageWarningBanner" data-sentry-source-file="ApiKeysList.tsx" />

      {/* Info text about shared quota */}
      <Typography sx={{
      ...typography.presets.caption,
      color: colors.text.tertiary,
      mb: 1
    }} data-sentry-element="Typography" data-sentry-source-file="ApiKeysList.tsx">
        {t('keyListSubtitle')}
      </Typography>

      {/* Key Cards */}
      {keys.map((key, index) => <ApiKeyCard key={key.id} keyData={key} onRevoke={onRevoke} index={index} />)}
    </Box>;
};
export default ApiKeysList;